import Swagger    from "swagger-client";
import {v4}       from "uuid";
import web_socket from "./web_socket";

let swagger_apis_hash;
let client;

let build_apis_hash = (client) => {
    let result = {};
    Object.keys(client.apis).forEach(tag_name => {
        Object.keys(client.apis[tag_name]).forEach(controller_name => {
            if(result.hasOwnProperty(controller_name))
                console.error("duplicated swagger controller names", controller_name);
            result[controller_name] = client.apis[tag_name][controller_name]
        })
    });

    return result;
};

const _init_events = () => ({
    "error" : []
});

let events = _init_events();

export const on = (event_name, fn) => {
    if(!events.hasOwnProperty(event_name))
    {
        return console.error("Wrong api event name:", event_name);
    }
    events[event_name].push(fn)
};

export const off = ( event_name ) =>
{
    if (event_name)
        events[event_name] = [];
    else
        events = _init_events();
};

export let init = async(config) => {
    const sid = v4();
    web_socket.init({token: config.token, sid: sid});
    let gene_token_cookie = config.token;
    let opt = gene_token_cookie && gene_token_cookie !== "undefined" ? {authorizations : {"authorization": 'Bearer ' + gene_token_cookie}} : {};
    opt.requestInterceptor = (req) => {
        req.headers['sid'] = sid;
        if (gene_token_cookie) req.headers['token'] = gene_token_cookie;
        return req
    }

    let swagger_url = `${process.env.REACT_APP_API_URL || config.origin || window.location.origin}/api/swagger?version=${config.version || 0}`;

    let cl = await Swagger(swagger_url, opt)
    swagger_apis_hash = build_apis_hash(cl);
    client = cl;
};

/**
 * @param {Object} res
 * @param {String} res.data - stringify response from server
 * @param {Object} options
 * @param {Object|Array} options.default_result
 * @param {String} [options.resultSource]
 *
 * @return {Object|Array}
 */

let transformResponseData = (res, options = {}) =>
{
    let data = res.response ? res.response.body : options.resultSource === "data" ? res.data : res.body || res.data;
    if ( !data ) {
        return options.default_result;
    }

    return data;
};

let wait_for_swagger_data = cb => {
    if (client)
        return cb();

    let interval = setInterval(() => {
        if (!client)
            return;

        clearInterval(interval);
        cb()
    })
};

/**
 *
 * @param {String} controller_name
 * @param {Object} data
 * @param {Object|Function} [options]
 * @param {Boolean} [options.return_error]
 * @param {Any} [options.default_result]
 * @param {String} [options.requestContentType]
 * @param {String} [options.resultSource] -> "body"|"data"
 * @param {Function} [callback]
 * @returns {function(): boolean|Promise<any>}
 */
let api = (controller_name, data, options = {}, callback) => {
    let is_cancel = false;
    let Cancel = () => is_cancel = true;

    if (options instanceof Function)
        callback = options;

    let _execute = (callback) => {
        wait_for_swagger_data(async () => {
            if (!swagger_apis_hash[controller_name])
                return console.error("Swagger controller not found:", controller_name);

            try {
                let result = await swagger_apis_hash[controller_name](data, { requestContentType: options.requestContentType || 'application/json' });
                if (is_cancel) {
                    return;
                }

                callback(transformResponseData(result, {resultSource: options.resultSource, default_result: options.default_result}), result.headers);
            }
            catch(e) {
                let error = {error: -200, message: ""};
                try {
                    error = transformResponseData(e.valueOf().response, {resultSource: options.resultSource, default_result: options.default_result});
                }
                catch (e) {
                    error = e
                }
                console.error(e);

                if (options.return_error) {
                    if (!error.error) {
                        error = { error: -200, message: e.toLocaleString()};
                    }

                    if (error.error === -7){
                        events["error"].forEach(fn => fn(error));
                    }
                    return callback(error || {});
                }
                else {
                    events["error"].forEach(fn => fn(error));
                    return callback({error: -200});
                }
            }
        });
    };

    if (!callback) {
        return new Promise(_execute)
    }

    _execute(callback);
    return Cancel;
};

export let api_chunk = (controller_name, data, options = {}, callback) => {
    let is_cancel = false;
    let Cancel = () => is_cancel = true;
    data = JSON.parse(JSON.stringify(data));

    if (options instanceof Function)
        callback = options;

    let loading = async () => {
        let loaded_count = 0;
        let count = 0;

        do {
            if (is_cancel)
                break;
            let result = await api(controller_name, data, options = {});
            data.data ? data.data._scroll_id = result._scroll_id : data._scroll_id = result._scroll_id;
            count = result.count;
            loaded_count += result.data ? result.data.length : 0;
            callback({result, load_percent: result.count ? Math.round(loaded_count * 100 / result.count) : 100});
        }
        while(loaded_count < count);
    };

    loading();
    return Cancel

};

export default api
